import { BaseBus } from "./BaseBus";
import { v_LocationDetailBus } from "./v_LocationDetailBus";
import { DateFunctions } from "../static/date-functions";
import { CommonFunctions } from "../static/common-functions";
import { CommonValues } from "../static/CommonValues";

export class v_DispatchAssignmentBus extends BaseBus
{
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
        this.assignedDate = DateFunctions.getDate(this.assignedDate);
        this.startDate = DateFunctions.getDate(this.startDate);
        this.endDate = DateFunctions.getDate(this.endDate);

    }
    CID(): any {
        return this.dispatchAssignmentId;
    }
    setId(id: any) {
        this.dispatchAssignmentId = id;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
        this.assignedDate = date;
        this.assignedStatusId = CommonValues.DispatchAssignment_Assigned;
        this.startDate = date;
        this.isPrimary = true;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }

    assignedDate: Date;
    startDate: Date;
    endDate: Date;
    fullName: string;
    dispatchAssignmentStatusName: string;
    isPrimary: boolean;
    dispatchNumber: string;
    dispatchStatusName: string;
    requireFieldValidation: boolean;
    wasCallback: boolean;
    acctMgr: string;
    CO: number;
    updateDt: Date;
    updateUserName: string;
    dispatchId: any;
    locationId: any;
    dispatchAssignmentId: any;
    assignedPersonId: any;
    assignedPersonName: any;
    assignedStatusId: any;
    dispatchStatusId: any;
    assignedByPersonId: any;
    assignedByPersonName: string;
    updateUserId: any;
    accountClassId: any;
    insertUserId: any;
    insertDt: Date;
    isCurrent: boolean;
    originalWasCallback: boolean;

}
